import React from 'react';

// COMPONENTS
import Icon from '../Icon/Icon';
import MenuMobile from '../MenuMobile';

// ENUMS
import { Icons } from '../../enums/icons';

// INTERFACE
import { IMenuMobile } from '../../interfaces/MenuMobile.interface';

// STYLES
import { Container, ActionArrow, NoArrow } from './styles';

const HeaderMobile: React.FC<IMenuMobile> = ({ showArrow, itemsMenu, titleMenu, actionArrow, logout }) => {
  return (
    <Container>
      {showArrow ? (
        <ActionArrow onClick={actionArrow}>
          <Icon type={Icons.ARROW_LEFT_BIG} />
        </ActionArrow>
      ) : (
        <NoArrow />
      )}
      <span>{titleMenu}</span>
      <MenuMobile showArrow={showArrow} itemsMenu={itemsMenu} logout={logout} />
    </Container>
  );
};

export default HeaderMobile;
